import { z } from 'zod';

export const chartPreferencesTypeEnum = z.enum(['bar', 'line', 'pie', 'stacked-bar', 'multiple-bar', 'multiple-line']);
export type ChartPreferencesType = z.infer<typeof chartPreferencesTypeEnum>;

export const chartRecordSchema = z.object({
  id: z.coerce.number(),
  initialChartType: chartPreferencesTypeEnum,
  overrideChartTypes: z.array(chartPreferencesTypeEnum),
});
export type ChartPreferencesRecord = z.infer<typeof chartRecordSchema>;
export const userPreferencesSchema = z.object({
  preferredChartType: chartPreferencesTypeEnum,
  confidence: z.number().min(0).max(1),
  recentUsageCount: z.int().nonnegative(),
});
export type UserChartPreferences = z.infer<typeof userPreferencesSchema>;